<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3">
        <v-select
          placeholder="Clients"
          multiple label="name" index="id"
          :options="f.clients"
          v-model="filters['clients']"
          @input="filterRegistrar"
        ></v-select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../mixins/helperMixin'
import { REGISTRAR_LIST_SET } from '../../../../store/mutation-types'

export default {
  data () {
    return {
      filters: {},
      multiFilters: {},
      showCompleted: false
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      registrars: 'getRegistrars'
    })
  },
  mounted () {
    // Reset filter
    this.$store.commit(REGISTRAR_LIST_SET, this.registrars.map(r => ({...r, show: true})))
  },
  methods: {
    filterRegistrar () {
      // Filter users based on clients filter
      const filterRegistrar = this.registrars.map(
        r => ({
          ...r,
          show: this.filters['clients'].length > 0
            ? this.filters['clients'].includes((r.client || {}).id)
            : true
        })
      )
      // Commit filtered results
      this.$store.commit(REGISTRAR_LIST_SET, filterRegistrar)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrars/Filters.vue